import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
const SvgIconCrop = (props) => (_jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", focusable: false, ...props, children: [_jsx("path", { d: "M19 7c0-1.103-.897-2-2-2H7V2H5v3H2v2h15v15h2v-3h3v-2h-3V7z" }), _jsx("path", { d: "M5 9v8c0 1.103.897 2 2 2h8v-2H7V9H5z" })] }));
const Memo = memo(SvgIconCrop);
export default Memo;
//# sourceMappingURL=IconCrop.js.map